const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';

/**
 * Animates `element.textContent` scrambling through random chars before
 * resolving to `finalText`. Calls `onDone` when complete.
 * Returns a cancel function.
 */
export function scrambleText(element, finalText, { fps = 24, onDone } = {}) {
  const frameMs = 1000 / fps;
  const totalFrames = finalText.length * 4; // ~4 scramble frames per character
  let frame = 0;
  let handle = null;
  let lastTime = 0;

  function tick(now) {
    if (now - lastTime < frameMs) {
      handle = requestAnimationFrame(tick);
      return;
    }
    lastTime = now;

    const revealed = Math.floor((frame / totalFrames) * finalText.length);
    let result = finalText.slice(0, revealed);

    for (let i = revealed; i < finalText.length; i++) {
      result += finalText[i] === ' ' ? ' ' : CHARS[Math.floor(Math.random() * CHARS.length)];
    }

    element.textContent = result;
    frame++;

    if (frame > totalFrames) {
      element.textContent = finalText;
      onDone?.();
      return;
    }

    handle = requestAnimationFrame(tick);
  }

  handle = requestAnimationFrame(tick);

  return () => {
    if (handle) cancelAnimationFrame(handle);
  };
}
